import React, { Component } from "react";
import axios from "axios"; // Single import for Axios
import { connect } from "react-redux";
import { configuration } from "../../appConfig";
import chiefLogo from '../../assets/img/brand/Report-footer.png';
import carrosoieLogo from '../../assets/img/brand/carrosserie-spiez.png';
import sws_ag from '../../assets/img/brand/sws-ag.png';
import header_second_logo from '../../assets/header-second-img.png';
import defaultLogo from "../../assets/img/brand/logo.png";
import fallbackAdiLogo from "../../assets/img/brand/Adi.png";

class ReportHeader_Swiss extends Component {
  state = {
    words: {},
    lang: "Gb",
    data: "",
    insuranceProviderInfo: [], // Changed from array to object
    fallbackInfo: {},
    jsonData: {},
    insuranceName: "",
    customerCompany: ""
  };

  componentDidMount() {
    this.initializeData();
  }

  // Initialize all data fetching
  initializeData = async () => {
    try {
      await this._getData();
      await this.getFallbackDetails();
      await this.getInsuranceName();
      await this.getInsurenceClients();
      this.getLang();
      const client = localStorage.getItem("client");
      if (client === "SWISS" || client === "POLAND") {
        this.getCustomerCompany();
      }
    } catch (error) {
      console.error("Error initializing data:", error);
    }
  };

  // Fetch language settings
  getLang = async () => {
    try {
      const base_url = window.location.origin;
      const res = await axios.get(`${base_url}/lang.json`);
      this.setState({ words: res.data, lang: localStorage.getItem("lang") || "Gb" });
    } catch (error) {
      console.error("Error fetching language data:", error);
    }
  };

  // Language translation method
  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };

  // Update language from props
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    }
    return null;
  }

  // Fetch main data
  _getData = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    try {
      const response = await axios.get(`${configuration.getData}?vin=${vin}&partnerId=${partnerId}`);
      if (response.data) {
        const { Datetime, InsurenceName } = response.data;
        this.setState({ 
          data: Datetime, 
          jsonData: response.data, 
          insuranceName: InsurenceName || "" 
        });
      } else {
        console.warn("No data received from getData API.");
      }
    } catch (error) {
      console.error("Error fetching main data:", error);
    }
  };

  // Fetch customer company details
  getCustomerCompany = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    const url = `${configuration.getSingleQRDetails}?partnerId=${partnerId}&vin=${vin}`;
    try {
      const res = await axios.get(url);
      if (res.data.data.length && res.data.data[0].hasOwnProperty('customerCompany')) {
        this.setState({
          customerCompany: res.data.data[0].customerCompany.toLowerCase()
        });
      } else {
        console.warn("customerCompany not found in response.");
      }
    } catch (error) {
      console.error("Error fetching customer company:", error);
    }
  };

  // Fetch fallback details
  getFallbackDetails = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const url = `${configuration.getFallbackDetails}?partner_id=${partnerId}`;
    try {
      const res = await axios.get(url);
      let fallbackData = {};

      if (res.data.success !== false) {
        const companyLogo = res.data.company_logo
          ? `${configuration.getFallbackLogoPath}${partnerId}/${res.data.company_logo}`
          : fallbackAdiLogo;

        fallbackData = {
          Logo: res.data.company_logo ? companyLogo : fallbackAdiLogo,
          Email: res.data.company_email || "sales@adi-gmbh.com",
          CompanyName: res.data.company_name || "Auto Damage Inspection GmbH",
          Website: res.data.company_website || "https://adi-gmbh.com",
          Address: res.data.company_address || "Kreuzstr 81, 85716 Unterschleißheim, Germany.",
          PrimaryColor: res.data.primary_color || "#FF0000",
          SecondaryColor: res.data.secondary_color || "#000000",
          PrimaryContact: res.data.contact_number || "08954809487",
          RegisterNo: res.data.company_registration_number || "HRB1234",
        };
      } else {
        fallbackData = {
          Logo: fallbackAdiLogo,
          Email: "sales@adi-gmbh.com",
          CompanyName: "Auto Damage Inspection GmbH",
          Website: "https://adi-gmbh.com",
          Address: "Kreuzstr 81, 85716 Unterschleißheim, Germany.",
          PrimaryColor: "#FF0000",
          SecondaryColor: "#000000",
          PrimaryContact: "08954809487",
          RegisterNo: "HRB1234",
        };
      }

      this.setState({ fallbackInfo: fallbackData });
    } catch (error) {
      console.error("Error fetching fallback details:", error);
      // Set default fallbackInfo in case of error
      this.setState({
        fallbackInfo: {
          Logo: fallbackAdiLogo,
          Email: "sales@adi-gmbh.com",
          CompanyName: "Auto Damage Inspection GmbH",
          Website: "https://adi-gmbh.com",
          Address: "Kreuzstr 81, 85716 Unterschleißheim, Germany.",
          PrimaryColor: "#FF0000",
          SecondaryColor: "#000000",
          PrimaryContact: "08954809487",
          RegisterNo: "HRB1234",
        }
      });
    }
  };

  // Fetch insurance name
  getInsuranceName = async () => {
    const { jsonData, insuranceName } = this.state;
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile").split("_")[0];

    if (jsonData.hasOwnProperty('InsurenceName') && jsonData.InsurenceName.trim() !== "") {
      localStorage.setItem("InsurenceName", jsonData.InsurenceName);
      this.setState({ insuranceName: jsonData.InsurenceName });
    } else if (partnerId) {
      const url = `${configuration.getCustomerInfo}?partnerId=${partnerId}&vin=${vin}`;
      try {
        const res = await axios.get(url);
        if (res.data.length) {
          const fetchedInsuranceName = res.data[0].InsurenceName || res.data[0].insurenceName || "";
          localStorage.setItem("InsurenceName", fetchedInsuranceName);
          this.setState({ insuranceName: fetchedInsuranceName });
        } else {
          localStorage.setItem("InsurenceName", "");
          console.warn("No insurance name found in getCustomerInfo response.");
        }
      } catch (error) {
        console.error("Error fetching insurance name:", error);
        localStorage.setItem("InsurenceName", "");
      }
    } else {
      localStorage.setItem("InsurenceName", "");
    }
  };

  // Fetch insurance clients
  getInsurenceClients = async () => {
  const partnerId = localStorage.getItem("partnerId");
  let { insuranceName, fallbackInfo } = this.state;

  // Handle null insuranceName
  if (insuranceName.toLowerCase() === 'null') {
    insuranceName = null;
  }

  if (insuranceName && partnerId) {
    const url = `${configuration.getInsurenceClients}?partnerId=${partnerId}`;
    try {
      const res = await axios.get(url);
      
      if (res.data && Array.isArray(res.data)) {
        // Find the matching insurance provider
        const insuranceProvider = res.data.find(
          (data) => data.Name && data.Name.toLowerCase() === (insuranceName || "").toLowerCase()
        );

        // Process the found insurance provider
          if (insuranceProvider.Logo) {
            insuranceProvider.Logo = `${configuration.imagePath}/scanImages/${partnerId}/insurenceClients/${insuranceProvider.Logo}`;
          }

          // Set state with the insurance provider info
          this.setState({ 
            insuranceProviderInfo: insuranceProvider 
          });
       
      } else {
        console.warn("Invalid data format received from getInsurenceClients API.");
        this.setState({ insuranceProviderInfo: fallbackInfo });
      }
    } catch (error) {
      console.error("Error fetching insurance clients:", error);
      this.setState({ insuranceProviderInfo: fallbackInfo });
    }
  } else {
    console.warn("No partnerId found in localStorage.");
    this.setState({ insuranceProviderInfo: fallbackInfo });
  }
};

  // Handle image load error
  _onImageError = () => {
    this.setState((prevState) => ({
      insuranceProviderInfo: {
        ...prevState.insuranceProviderInfo,
        Logo: defaultLogo
      }
    }));
  };

  render() {
    const { insuranceProviderInfo, fallbackInfo, data, jsonData, insuranceName, customerCompany } = this.state;
    const partnerId = localStorage.getItem("partnerId");
    const client = localStorage.getItem("client");

    // Determine primary color
    const primaryColor = insuranceProviderInfo.PrimaryColor || fallbackInfo.PrimaryColor || '#D92029';
    const linearGradient = `linear-gradient(45deg, ${primaryColor} 50%, hsla(0,0%,100%,0) 0)`;

    // Determine logo source
    let logoSrc = fallbackInfo.Logo; // Default to fallback
    if ((client === "SWISS" || client === "POLAND") && (customerCompany === "carrosserie spiez ag" || partnerId === '19-spiez')) {
      logoSrc = carrosoieLogo;
    } else {
      if (partnerId === 'sws-ag') {
        logoSrc = sws_ag;
      } else if (partnerId === '10-200410' || partnerId === '21-220221') {
        logoSrc = chiefLogo;
      } else if (insuranceProviderInfo.Logo) {
        logoSrc = insuranceProviderInfo.Logo;
      }
    }

    // Determine VIN display
    const displayVIN = client === "SWISS" 
      ? (jsonData.OrderNo || localStorage.getItem("selectedFile"))
      : (jsonData.vin || localStorage.getItem("selectedFile"));

    // Format date and time
    let formattedDateTime = "";
    if (data) {
      const parts = data.split("_");
      if (parts.length >= 5) {
        formattedDateTime = localStorage.getItem('lang') === 'de'
          ? `${parts[2]}-${parts[1]}-${parts[0]} ${parts[3]}:${parts[4]}`
          : `${parts[2]}-${parts[1]}-${parts[0]} ${parts[3]}:${parts[4]}`;
      }
    }

    return (
      <div className="container-fluid p-0 report_header_wrapper">
        <div className="row p-0 report-header-row d-flex align-items-end">
          {/* First Column */}
          <div
            className="col-6 header-blue-first-border report-header-col h-100"
            style={{ borderBlockColor: primaryColor }}
          >
            <div className="header-customer-first-logo">
              <img
                onError={this._onImageError}
                src={logoSrc}
                alt="Company Logo"
              />
              <div className="header-center-block" style={{ background: linearGradient }}></div>
            </div>
          </div>

          {/* Second Column */}
          <div
            className="col-6 report-header-col header-blue-second-border"
            style={{ borderBlockColor: primaryColor }}
          >
            <div className="header-customer-second-logo">
              {/* <img src={header_second_logo} alt="Second Logo" /> */}
              <p>{this.lang("Scan Report")}</p>
            </div>
            <div className="header-text-wrapper">
              <h6 className="header-title-text">
                <small>
                  {client === "SWISS" || client === "POLAND" ? this.lang("DashboardVIN") + " : " :
                    client === "US" ? this.lang("VIN") + " : " :
                      this.lang("VIN Number") + " : "}
                </small>
                <span>{displayVIN}</span>
              </h6>
            </div>
            {/* {formattedDateTime && (
              <p style={{ backgroundColor: fallbackInfo.SecondaryColor || '#D92029' }}>
                {this.lang("Date and Time")}: {formattedDateTime}
              </p>
            )} */}
          </div>
        </div>
      </div>
    );
  }
}

// Map Redux state to component props
const mapStateToProps = (state) => ({
  lang: state.lang,
});

export default connect(mapStateToProps)(ReportHeader_Swiss);
